import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const SfEnvelopeIcon = (props: IconProps) => {
  return (
    <StyledIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9912 12.4365C11.7334 12.4365 11.4697 12.3193 11.2002 12.085L2.37598 4.25391C2.84473 3.98438 3.41895 3.84961 4.09863 3.84961H19.8926C20.5723 3.84961 21.1436 3.98438 21.6064 4.25391L12.7822 12.085C12.5186 12.3193 12.2549 12.4365 11.9912 12.4365ZM1.33887 17.833C1.26855 17.6572 1.21289 17.4639 1.17188 17.2529C1.13672 17.0361 1.11914 16.793 1.11914 16.5234V6.80273C1.11914 6.50977 1.13965 6.25195 1.18066 6.0293C1.22168 5.80078 1.27441 5.62207 1.33887 5.49316L7.87793 11.3027L1.33887 17.833ZM3.90527 19.4766C3.58887 19.4766 3.29883 19.4414 3.03516 19.3711C2.77734 19.3066 2.55762 19.2188 2.37598 19.1074L9.1084 12.3838L10.251 13.3945C10.5322 13.6465 10.8135 13.834 11.0947 13.957C11.3818 14.0742 11.6807 14.1328 11.9912 14.1328C12.3018 14.1328 12.6006 14.0742 12.8877 13.957C13.1748 13.834 13.4619 13.6465 13.749 13.3945L14.8828 12.3838L21.6152 19.1074C21.4336 19.2188 21.2109 19.3066 20.9473 19.3711C20.6895 19.4414 20.4023 19.4766 20.0859 19.4766H3.90527ZM22.6523 17.833L16.1133 11.3027L22.6523 5.49316C22.7109 5.62207 22.7607 5.80078 22.8018 6.0293C22.8486 6.25195 22.8721 6.50977 22.8721 6.80273V16.5234C22.8721 16.793 22.8516 17.0361 22.8105 17.2529C22.7695 17.4639 22.7168 17.6572 22.6523 17.833Z"
        fill="currentColor"
      />
    </StyledIcon>
  )
}
